import { render, staticRenderFns } from "./DistrictListPage.vue?vue&type=template&id=b60c83dc&scoped=true&"
import script from "./DistrictListPage.vue?vue&type=script&lang=js&"
export * from "./DistrictListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60c83dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b60c83dc')) {
      api.createRecord('b60c83dc', component.options)
    } else {
      api.reload('b60c83dc', component.options)
    }
    module.hot.accept("./DistrictListPage.vue?vue&type=template&id=b60c83dc&scoped=true&", function () {
      api.rerender('b60c83dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/DistrictListPage.vue"
export default component.exports